export const billiard = '※'